import { AddressModel, ClientModel, DebtModel, EnterpriseModel, EquipmentModel, TYPE_SEARCH, UserModel } from 'shared';

export interface ContractModel {
  id: string;
  docNumber: number;
  createdAt: string;
  version: number;
  equipment: EquipmentModel;
  equipmentId?: string;
  street: AddressModel['street'],
  country: AddressModel['country'],
  city: AddressModel['city'],
  client?: ClientModel;
  clientId?: string;
  debt?: DebtModel;
  debtId?: string;
  updater?: UserModel;
  isChanged?: boolean;
  isNew?: boolean;
  enterpriseId?: string;
  enterprise?: EnterpriseModel;
  isCanceled: boolean;
  comment?: string;
  contractStatus?: ContractStatus;
}


export interface ContractsFilterModel {
  isDebt?: boolean;
  searchText?: string;
  typeSearch?: TYPE_SEARCH;
}


export interface ContractModelExpectBackend {
  id: string;
  version: number;
  docNumber: number;
  createdAt: string;
  equipment: EquipmentModel;
  street: string;
  country: string;
  city: string;
  client: ClientModel;
  debtId: string;
  debt: DebtModel;
  enterprise: EnterpriseModel;
  isCanceled: boolean;
  isNew?: boolean;
  contractStatus?: ContractStatus;
  contractPeriod: number;
}


export interface ContractStatus {
  contractEndDate: string;
  contractPeriod: number;
  contractStatus: ContractStatusType;
  createdAt: string;
  id: string;
}

export enum ContractStatusType {
  ACTIVE = 'active',
  EXPIRED = 'expired'
}

export const CONTRACT_STATUS_RELATIONS_NAME: { [status: string]: string } = {
  [ContractStatusType.ACTIVE]: 'Договір дійсний до',
  [ContractStatusType.EXPIRED]: 'Термін дії вичерпався'
};

export const CONTRACTS_LOCAL_STORAGE_KEY = 'contracts_data';
